module.exports = __webpack_public_path__ + "static/media/bunu.e839caf7.gif";